<template>
  <div>
    <a-tree-select
      v-if="data"
      allow-clear
      show-search
      tree-node-filter-prop="title"
      v-model:value="selectedValue"
      :disabled="disabled"
      :multiple="multiple"
      :placeholder="placeholder"
      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
      :tree-checkable="multiple"
      :tree-data="afterData(data?.treeRecords)"
      :fieldNames="{ label: 'name', key: 'id', value: 'id' }"
      :showCheckedStrategy="SHOW_All"
      :treeCheckStrictly="treeCheckStrictly"
      @change="onChange"
      @clear="onClear"
    ></a-tree-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, watch, ref, onUnmounted } from "vue";
import { CategoryService } from "@/views/material/category/category.service";
import { TreeSelect } from "ant-design-vue";
/**
 * 材料分类选择器
 *
 * 使用方法:
 * <material-category-select v-model:value="formRef.categoryId"></material-category-select>
 */
export default defineComponent({
  name: "MaterialCategorySelect",
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: [String, Array],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    level2: {
      type: Boolean,
      default: false,
    },
    isRelative: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = CategoryService.useSimpleListApi();
    const SHOW_All = TreeSelect.SHOW_ALL;
    const selectedValue = ref<string | undefined | unknown[]>(undefined);

    // 修改计算分类
    const afterData = (obj) => {
      if (props.level2) {
        obj.forEach((item) => {
          if (item.children) {
            item.children.forEach((item1) => {
              delete item1.children;
            });
          }
        });
        return obj;
      }
      return obj;
    };

    const onChange = (value: string | string[]) => {
      // console.log("🚀 ~ file: index.vue ~ line 81 ~ onChange ~ value", value);
      let transitionValue: any = value;
      if (props.multiple && props.value && props.value.length > 0) {
        transitionValue = [];
        (value as any).map((e) => {
          if (typeof e === "object") {
            transitionValue.push(e.value);
          } else {
            transitionValue.push(e);
          }
        });
      }
      emit("update:value", transitionValue);
      emit("change", transitionValue);
    };

    const onClear = () => {
      emit("update:value", props.multiple ? [] : "");
    };
    const treeCheckStrictly = ref(false);
    onMounted(async () => {
      await run();
      if ((props.multiple && props.value && props.value.length > 0) || props.isRelative) {
        treeCheckStrictly.value = true;
        let d: any = [];
        data?.value?.records.map((e) => {
          if (props.value?.includes(e.id)) {
            d = [...d, { value: e.id, label: e.name }];
          }
        });
        selectedValue.value = d;
      } else {
        selectedValue.value = props.value;
      }
    });
    watch(()=>props.value,(n)=>{
      selectedValue.value = n;
    },{immediate:true})
    onUnmounted(() => {
      selectedValue.value = undefined;
    });

    return {
      data,
      loading,
      onChange,
      onClear,
      run,
      afterData,
      SHOW_All,
      treeCheckStrictly,
      selectedValue,
    };
  },
});
</script>
<style scoped="scoped">
:deep(.ant-select-tree) {
  overflow: auto;
  height: 100px !important;
}
:deep(.ant-select-tree-dropdown) {
  height: 100px !important;
}
</style>
